import { local, aws } from './envs'
import { Swiper, Navigation, Pagination } from 'swiper/swiper.esm'

let requestsMethodsTypes = {
	/* Login */
	login: {
		route: 'login',
		type: 'GET',
	},
	/* get main properties*/
	getMainProps: {
		route: 'shop/properties/$shopId',
		type: 'GET',
	},
	/* get main properties*/
	getSubShops: {
		route: 'shop/subshops',
		type: 'GET',
	},
	/* get main properties*/
	getShopCodes: {
		route: 'shop/$shopId/codes',
		type: 'GET',
	},
	/* get main properties*/
	getShopSettings: {
		route: 'shop/properties/$merchantShopCode',
		type: 'GET',
	},
	getOrders: {
		route: 'orders',
		type: 'GET',
	},
	getLocalization: {
		route: 'texts/shopId/$shopId/language/$lang',
		type: 'GET',
	},
}

let states = {
	ARRIVED: 'ARRIVED',
	REJECTED: 'REJECTED',
	REMOVED: 'REMOVED',
	PENDING: 'PENDING',
	PROCESSED: 'ALL_ITEMS_BACK',
	NOT_PROCESSED: 'NOT_PROCESSED',
	PRE_APPROVAL: 'PRE_APPROVAL',
}

let orderStatusLabelsKeys = {
	RETURN_NOT_ALLOWED: 'order.status.returnNotAllowed',
	RECONVERSION: 'order.status.reconversion',
	RETURNED: 'order.status.returned',
}

/* Localization Default Supported language */
let supportedLanguages = [
	{ name: 'english', code: 'en' },
	{ name: 'swedish', code: 'sv' },
]

let iframeEvents = {
	OPEN_RETURNADO_WIDGET: 'OPEN_RETURNADO_WIDGET',
}

let flowSteps = {
	SELECT: 'SELECT',
	RETURN: 'RETURN',
	COMPLAINT: 'COMPLAINT',
	EXCHANGE: 'EXCHANGE',
	SHIPPING: 'SHIPPING',
	REFUND: 'REFUND',
}

let flows = {
	refund: 'RETURN',
	exchange: 'EXCHANGE',
	reclamation: 'COMPLAINT',
}

let numbersAnimation = {
	numberAnimationDuration: 1000,
	numberStepPrecision: 0,
}

/* Configurations for different Environments */

const baseConfig = {
	states: states,
	iframeEvents: iframeEvents,
	supportedLanguages: supportedLanguages,
	orderStatusLabelsKeys: orderStatusLabelsKeys,
	requestsMethodsTypes: requestsMethodsTypes,
	flowSteps: flowSteps,
	flows: flows,
	numbersAnimation: numbersAnimation,
}

export default process.env.NODE_ENV === 'development'
	? Object.assign(baseConfig, local)
	: Object.assign(baseConfig, aws)

/**
 * swiperDefaultOptions {Object}
 * @description - set common (default) options for all Swiper sliders
 * */
export const swiperDefaultOptions = {
	Swiper,
	modules: [Navigation, Pagination],
	loop: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
}

/**
 * swiperOptionsForPopup {Object}
 * @description - set options for slider product popup window on Exchange step
 * */
export const swiperOptionsForPopup = {
	...swiperDefaultOptions,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
}
